import { render, staticRenderFns } from "./VoicesListItem.vue?vue&type=template&id=2a871dac&"
import script from "./VoicesListItem.vue?vue&type=script&lang=js&"
export * from "./VoicesListItem.vue?vue&type=script&lang=js&"
import style0 from "./VoicesListItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports